import { gql } from '@/__generated__';

const GET_SENSORS = gql(`#graphql
  query MathModeling_GetSensors($input: DeviceInput!) {
    device(input: $input) {
      id
      sensors {
        id
        deviceId
        childDeviceId
        telemetrySensorId
        fields {
          id
          name
          influxMeasurement
          influxField
          unit
        }
      }
    }
  }
`);

export default GET_SENSORS;
